import type { SVGProps } from "react";
export interface PearIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PearIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PearIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.205 15.204a1.126 1.126 0 0 1 1.505-.077l.085.077.324.307c.31.275.585.46.869.59.371.169.833.274 1.523.274a3 3 0 0 0 .302-.054l.183-.047.051-.015.012-.004h.002l.11-.028a1.125 1.125 0 0 1 .545 2.18v.001h-.004l-.007.003-.107.03a7 7 0 0 1-.268.07 3.8 3.8 0 0 1-.819.114c-.931 0-1.725-.145-2.453-.476a5.7 5.7 0 0 1-1.434-.957l-.42-.397-.077-.085a1.126 1.126 0 0 1 .078-1.506m12.244-12.23c1.152-1.018 2.45-1.268 3.62-1.001l.249.064.108.038a1.126 1.126 0 0 1-.631 2.148l-.113-.028-.202-.047c-.417-.073-.9 0-1.42.411l-.265.236-.25.25a1.125 1.125 0 0 1-1.59-1.59l.25-.25.244-.23Z"
      />
      <path
        fill={color}
        d="M13.908 2.254c1.673-.671 3.89-.551 5.64 1.199l.329.354c1.536 1.807 1.497 4.016.724 5.612-.381.786-.753 1.224-1.02 1.585a5 5 0 0 0-.579.986l-.22.539c-.212.568-.405 1.315-.727 2.342-.304.967-.694 2.077-1.25 3.125-1.121 2.115-3.012 4.129-6.294 4.129-2.838 0-4.934-.89-6.84-2.796S.875 15.327.875 12.489c0-3.282 2.014-5.173 4.13-6.294 1.048-.556 2.157-.946 3.124-1.25 1.027-.322 1.774-.515 2.342-.728l.54-.22a5 5 0 0 0 .985-.578c.361-.267.799-.639 1.585-1.02zM3.125 12.49c0 2.246.657 3.768 2.137 5.249s3.003 2.137 5.249 2.137c2.127 0 3.395-1.217 4.305-2.933.46-.867.804-1.824 1.093-2.745.27-.86.528-1.823.766-2.458.389-1.037.745-1.596 1.097-2.072.327-.442.537-.678.804-1.23l.082-.185c.36-.89.327-2.024-.51-3.002l-.192-.207c-1.089-1.09-2.42-1.09-3.393-.62-.552.268-.788.478-1.23.805-.476.352-1.034.709-2.072 1.097-.635.238-1.597.496-2.458.766-.921.29-1.878.633-2.745 1.093-1.716.91-2.933 2.178-2.933 4.305"
      />
    </svg>
  );
}
